import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import RegisterView from '@/views/RegisterView.vue'
import ResetView from '@/views/ResetView.vue'
import ListView from '@/views/ListView.vue'
import LoginView from '../views/LoginView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true } //這個頁面需要登入才能看
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: { requiresAuth: true }
  },
  {
    path: '/reset',
    name: 'reset',
    component: ResetView,
    meta: { requiresAuth: true }
  },
  {
    path: '/list',
    name: 'list',
    component: ListView,
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // 檢查該頁面是否需要驗證 (有沒有 meta.requiresAuth)
  if (to.meta.requiresAuth) {
    // 檢查瀏覽器有沒有存剛剛的通行證
    const isAuthenticated = sessionStorage.getItem('isAuthenticated');

    if (isAuthenticated) {
      next(); // 有通行證，放行
    } else {
      next('/login'); // 沒通行證，踢去登入頁
    }
  } else {
    next(); // 不需要驗證的頁面(如 login)，直接放行
  }
})

export default router
